import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  IconButton,
  Fade,
  Paper,
  Chip,
  Divider,
  Avatar,
  Grid,
  Tooltip as MuiTooltip,
  InputAdornment,
} from "@mui/material";
import {
  Close as CloseIcon,
  Add as AddIcon,
  ArrowBack as ArrowBackIcon,
  Visibility,
  VisibilityOff,
  Delete,
  Settings,
  SubdirectoryArrowRight,
  LinkOff,
  Category as CategoryIcon,
  Search,
} from "@mui/icons-material";
import { Tooltip } from "react-tooltip";
import { Link, useNavigate } from "react-router-dom";
import { MultiSelectDropdown } from "./MultiSelectDopdown";
import CategorySlidePanelForm from "./CategorySlidePanelForm";
import axios from "axios";
import { getLanguageText } from "../../utils/multilanguageUtils";

const SubCategoryView = ({
  category,
  onClose,
  userId,
  buttonColor,
  existingSubCategories = [],
  allSubCategories = [],
  onCreateNew,
  onLinkExisting,
  onUnlink,
  onToggleVisibility,
  onDelete,
  frontendCategories,
  selectedParentCategories,
  setSelectedParentCategories,
  searchTerm = "",
  handleToggleVisibility,
  filteredSubCategories,
  onSearchChange = () => {},
  currentLanguage = 'en', // Add currentLanguage prop with default
}) => {
  const [newSubCategoryName, setNewSubCategoryName] = useState("");
  const [newSubCategoryDescription, setNewSubCategoryDescription] =
    useState("");
  const [selectedExistingSubCategories, setSelectedExistingSubCategories] =
    useState([]);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showLinkForm, setShowLinkForm] = useState(false);
  const navigate = useNavigate();

  console.log("filteredSubCategories", filteredSubCategories);

  // Ensure filteredSubCategories is always an array
  const safeFilteredSubCategories = Array.isArray(filteredSubCategories)
    ? filteredSubCategories
    : [];

  // Filter available subcategories (not already linked to this category)
  const availableSubCategories = allSubCategories.filter(
    (sub) =>
      !safeFilteredSubCategories.some((linked) => linked._id === sub._id),
  );

  const searchedSubCategories = searchTerm
    ? safeFilteredSubCategories.filter(
        (sub) => {
          const name = getLanguageText(sub.name, currentLanguage).toLowerCase();
          const description = getLanguageText(sub.description, currentLanguage).toLowerCase();
          const searchLower = searchTerm.toLowerCase();
          return name.includes(searchLower) || description.includes(searchLower);
        }
      )
    : safeFilteredSubCategories;

  console.log("searchedSubCategories", searchedSubCategories);

  // Reset selected subcategories when category changes
  useEffect(() => {
    setSelectedExistingSubCategories([]);
    setShowCreateForm(false);
    setShowLinkForm(false);
  }, [category._id]);

  // Auto-hide forms when searching
  useEffect(() => {
    if (searchTerm) {
      setShowCreateForm(false);
      setShowLinkForm(false);
    }
  }, [searchTerm]);

  const handleCreateNew = async () => {
    if (!newSubCategoryName.trim()) return;

    const categoryId = category?._id;

    // Wait for the parent's create function to complete
    await onCreateNew(
      {
        name: newSubCategoryName,
        description: newSubCategoryDescription,
        parentCategories: [category._id],
      },
      categoryId,
    );

    // Only clear state after the operation completes
    setNewSubCategoryName("");
    setNewSubCategoryDescription("");
    setShowCreateForm(false);
  };

  const handleLinkExisting = async () => {
    if (selectedExistingSubCategories.length === 0) return;

    // Call the parent's link function and wait for it to complete
    await onLinkExisting(selectedExistingSubCategories, category._id);

    // Only clear state after the operation completes
    setSelectedExistingSubCategories([]);
    setShowLinkForm(false);
  };

  console.log("category in SubCategoryView:", selectedExistingSubCategories);

  const truncateText = (text, maxLength) => {
    if (!text) return "";
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  };

  const [isOpen, setIsOpen] = useState(false);
  const [config, setConfig] = useState({
    numColumns: 1,
    columnSpacing: 10,
    enableOffset: true,
    leftOffset: 5,
    rightOffset: 0,
    topOffset: 5,
    disableAnimation: false,
    buttonAlignment: "center",
  });

  // Load settings when userId changes
  useEffect(() => {
    if (userId) {
      fetchSettings();
    }
  }, [userId]);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(
        `/api/wayfinder/frontend-main-category-settings/${userId}`,
      );
      if (response.data.success) {
        const settings = response.data.data;
        setConfig((prev) => ({
          ...prev,
          ...settings,
        }));
      }
    } catch (error) {
      console.error("Error fetching category settings:", error);
    }
  };

  const handleSavePanelSettings = async (newConfig) => {
    try {
      const response = await axios.post(
        `/api/wayfinder/frontend-main-category-settings/${userId}`,
        {
          ...newConfig,
          userId: userId,
        },
      );

      if (response.status === 200) {
        console.log("Settings saved successfully:", response.data);
        return { success: true, data: response.data };
      }

      return { success: false, error: "Failed to save settings" };
    } catch (error) {
      console.error("Error saving settings:", error);
      return {
        success: false,
        error: error.response?.data?.error || "Failed to save settings",
      };
    }
  };

  const openPanel = () => setIsOpen(true);
  const closePanel = () => setIsOpen(false);

  return (
    <div className="min-height-200px">
      <div className="row">
        <div className="col-md-12">
          <div
            className=" "
            style={{ marginRight: "15px", width: "100%", padding: "20px" }}
          >
            <div className="menu-title">
              <span>
                {searchTerm
                  ? `Search Results (${searchedSubCategories.length})`
                  : `${getLanguageText(category.name, currentLanguage)} Subcategories (${searchedSubCategories.length})`}
              </span>
            </div>

            {/* Action Buttons Inside Card - Only show when NOT searching */}
            {!searchTerm && (
              <div
                className="form-group"
                style={{
                  display: "flex",
                  gap: "10px",
                  padding: "15px",
                  borderBottom: "1px solid #eee",
                  marginBottom: "10px",
                }}
              >
                <button
                  type="button"
                  style={{ backgroundColor: buttonColor, flex: 1 }}
                  className="btn btn-success"
                  onClick={() => {
                    setShowCreateForm(!showCreateForm);
                    setShowLinkForm(false);
                  }}
                >
                  <AddIcon /> Create New Subcategory
                </button>
                <button
                  type="button"
                  style={{
                    borderColor: buttonColor,
                    color: buttonColor,
                    backgroundColor: "transparent",
                    flex: 1,
                  }}
                  className="btn btn-outline-success"
                  onClick={() => {
                    setShowLinkForm(!showLinkForm);
                    setShowCreateForm(false);
                  }}
                >
                  Link Existing
                </button>
              </div>
            )}

            {/* Create New Form Inside Card */}
            {!searchTerm && showCreateForm && (
              <Fade in={showCreateForm}>
                <div
                  style={{
                    padding: "15px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "4px",
                    marginBottom: "15px",
                  }}
                >
                  <div
                    className="menu-title"
                    style={{ fontSize: "16px", marginBottom: "10px" }}
                  >
                    <span>Create New Subcategory</span>
                  </div>

                  <div className="form-group" style={{ marginBottom: "10px" }}>
                    <input
                      type="text"
                      placeholder="Enter Subcategory Name"
                      value={newSubCategoryName}
                      onChange={(e) => setNewSubCategoryName(e.target.value)}
                      className="form-control"
                    />
                  </div>

                  {/* <div className="form-group" style={{ marginBottom: '10px' }}>
                    <textarea
                      placeholder="Description (Optional)"
                      value={newSubCategoryDescription}
                      onChange={e => setNewSubCategoryDescription(e.target.value)}
                      className="form-control"
                      rows="3"
                    />
                  </div> */}

                  <div
                    className="form-group"
                    style={{ display: "flex", gap: "10px" }}
                  >
                    <button
                      style={{ backgroundColor: buttonColor }}
                      className="btn btn-success"
                      onClick={handleCreateNew}
                      disabled={!newSubCategoryName.trim()}
                    >
                      Create
                    </button>
                    <button
                      className="btn btn-outline-secondary"
                      onClick={() => {
                        setShowCreateForm(false);
                        setNewSubCategoryName("");
                        setNewSubCategoryDescription("");
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Fade>
            )}

            {/* Link Existing Form Inside Card */}
            {!searchTerm && showLinkForm && (
              <Fade in={showLinkForm}>
                <div
                  style={{
                    padding: "15px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "4px",
                    marginBottom: "15px",
                  }}
                >
                  <div
                    className="menu-title"
                    style={{ fontSize: "16px", marginBottom: "10px" }}
                  >
                    <span>Link Existing Subcategories</span>
                  </div>

                  <div className="form-group">
                    <MultiSelectDropdown
                      label="Select Subcategories"
                      options={availableSubCategories?.map((sub) => ({
                        _id: sub._id,
                        name: sub.name,
                      }))}
                      selectedValues={selectedExistingSubCategories}
                      onChange={(val) => setSelectedExistingSubCategories(val)}
                      placeholder="Choose subcategories to link..."
                      maxLabelLength={30}
                      currentLanguage={currentLanguage}
                    />
                  </div>

                  <div
                    className="form-group"
                    style={{ display: "flex", gap: "10px", marginTop: "10px" }}
                  >
                    <button
                      style={{ backgroundColor: buttonColor }}
                      className="btn btn-success"
                      onClick={handleLinkExisting}
                      disabled={selectedExistingSubCategories.length === 0}
                    >
                      Link Selected
                    </button>
                    <button
                      className="btn btn-outline-secondary"
                      onClick={() => {
                        setShowLinkForm(false);
                        setSelectedExistingSubCategories([]);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Fade>
            )}

            {/* Render Subcategories */}
            <ul className="submenu-list" style={{ minHeight: "119px" }}>
              {searchedSubCategories.length === 0 ? (
                <li
                  className="submenu-item"
                  style={{ justifyContent: "center", color: "#666" }}
                >
                  {searchTerm
                    ? `No subcategories found matching "${searchTerm}"`
                    : "No subcategories linked yet. Create a new one or link an existing subcategory."}
                </li>
              ) : (
                searchedSubCategories.map((subCategory) => {
                  const subCategoryName = getLanguageText(subCategory.name, currentLanguage);
                  const subCategoryDescription = getLanguageText(subCategory.description, currentLanguage);
                  
                  return (
                    <li className="submenu-item" key={subCategory._id}>
                      <span
                        data-tooltip-id={`tooltip-${subCategory._id}`}
                        data-tooltip-content={
                          subCategoryName.length > 20 ? subCategoryName : ""
                        }
                      >
                        {truncateText(subCategoryName, 20)}
                      </span>

                      {subCategoryDescription && (
                        <span
                          style={{
                            fontSize: "0.8em",
                            color: "#666",
                            marginLeft: "5px",
                          }}
                        >
                          - {truncateText(subCategoryDescription, 30)}
                        </span>
                      )}

                      <Tooltip
                        id={`tooltip-${subCategory._id}`}
                        place="top"
                        style={{ backgroundColor: buttonColor, zIndex: 9999 }}
                        effect="float"
                      />

                    <div>
                      {subCategory.status ? (
                        <span
                          className="bi bi-eye micon"
                          onClick={() =>
                            handleToggleVisibility(
                              subCategory._id,
                              subCategory.status,
                            )
                          }
                        ></span>
                      ) : (
                        <span
                          className="bi bi-eye-slash micon"
                          onClick={() =>
                            handleToggleVisibility(
                              subCategory._id,
                              subCategory.status,
                            )
                          }
                        ></span>
                      )}

                      <Link
                        to={`/wayfinder-sub-category/${userId}/${subCategory._id}`}
                      >
                        <span className="bi bi-gear micon"></span>
                      </Link>

                      <MuiTooltip title="Unlink from this category">
                        <span
                          className="bi bi-link-45deg micon"
                          style={{ color: "#ff9800" }}
                          onClick={() => {
                            if (
                              window.confirm(
                                `Unlink "${subCategoryName}" from this category? The subcategory will not be deleted.`,
                              )
                            ) {
                              onUnlink(subCategory._id, category?._id);
                            }
                          }}
                        ></span>
                      </MuiTooltip>

                      <MuiTooltip title="Delete subcategory permanently">
                        <span
                          className="bi bi-trash micon"
                          onClick={() => {
                            if (
                              window.confirm(
                                `Delete "${subCategoryName}" permanently? This will remove it from all categories.`,
                              )
                            ) {
                              onDelete(subCategory._id, category?._id);
                            }
                          }}
                        ></span>
                      </MuiTooltip>
                    </div>
                  </li>
                  );
                })
              )}
            </ul>

            {/* Add New Subcategory Form at Bottom */}
            {/* {!searchTerm && !showCreateForm && (
              <div
                className="form-group"
                style={{ display: 'flex', paddingTop: '15px', borderTop: '1px solid #eee' }}
              >
                <input
                  type="text"
                  placeholder="Enter Subcategory Name"
                  value={newSubCategoryName}
                  onChange={e => setNewSubCategoryName(e.target.value)}
                  className="form-control"
                />
                <button
                  style={{ backgroundColor: buttonColor }}
                  className="add-btn"
                  onClick={handleCreateNew}
                  disabled={!newSubCategoryName.trim()}
                >
                  +
                </button>
              </div>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubCategoryView;
